module.exports = __webpack_public_path__ + "img/home3.77537bbf.jpg";